<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 12.4273V3.85714C11 3.38376 11.4477 3 12 3C12.5523 3 13 3.38376 13 3.85714V12.4272L15.8636 9.56365C16.215 9.21218 16.7849 9.21218 17.1363 9.56365C17.4878 9.91512 17.4878 10.485 17.1363 10.8364L12.6364 15.3364C12.2849 15.6879 11.715 15.6879 11.3636 15.3364L6.86356 10.8364C6.51209 10.485 6.51209 9.91512 6.86356 9.56365C7.21503 9.21218 7.78488 9.21218 8.13635 9.56365L11 12.4273ZM3 17V14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14V17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17Z"
      fill="currentColor"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
